import { enqueueSnackbar } from "notistack"
import { useApiMutation } from "../../../../../core/api/useApiMutation"
import { deleteExtraService, ExtraServicesQuery } from "../extraServicesApi"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { DeleteConfirmDialog } from "../../../../../shared/components/dialogs/DeleteConfirmDialog"

export const defaultConfirmModalState = { showConfirmModal: false, confirmModalText: "", productId: null }

export type DefaultConfirmModalStateType = Readonly<{
    showConfirmModal: boolean
    confirmModalText: string
    productId: null | number
}>

type DeleteExtraServiceDialogProps = Readonly<{
    confirmModalState: DefaultConfirmModalStateType
    setConfirmModalState: React.Dispatch<React.SetStateAction<DefaultConfirmModalStateType>>
}>

export const DeleteExtraServiceDialog = ({
    confirmModalState,
    setConfirmModalState,
}: DeleteExtraServiceDialogProps) => {
    const { mutate: callDeleteProduct } = useApiMutation(deleteExtraService, {
        async onSuccess(params, data, context) {
            await context.queryClient.invalidateQueries({ queryKey: [ExtraServicesQuery.LIST] })
            enqueueSnackbar({
                variant: "success",
                message: data.serviceResponse.displayMessage,
            })
        },
    })

    return (
        <LocalizedStrict id="products-confirm-delete-product-dialog" attrs={{ typeOfEntity: true }}>
            <DeleteConfirmDialog
                typeOfEntity="product"
                entityName={confirmModalState.confirmModalText}
                handleClick={() => {
                    if (confirmModalState.productId != null) {
                        callDeleteProduct({ productId: confirmModalState.productId })
                    } else {
                        throw new Error("Product id is undefined")
                    }
                }}
                onClose={() => setConfirmModalState(defaultConfirmModalState)}
                open={confirmModalState.showConfirmModal}
            />
        </LocalizedStrict>
    )
}
